import styles from './Board.module.scss'
import classNames from "classnames";
import {CellToQuestionMapping} from "@/utils/crossword";


type Props = {
  board: string[][],
  userBoard: string[][],
  checkedBoard: string[][],
  onCellSelected: (i: number, j: number) => void
  selectedCell?: {x: number, y: number}
  goingAcross: boolean
  questionMap: CellToQuestionMapping[][]
}

const Board = ({board, userBoard, onCellSelected, selectedCell, goingAcross, questionMap, checkedBoard}: Props) => {
  return (
    <div className={styles.container} style={{aspectRatio: `${board[0].length} / ${board.length}`}}>
      {board.map((row, i) => (
        <div className={styles.row} key={i}>
          {row.map((cell, j) => (
            <div
              key={j}
              onClick={() => onCellSelected(i,j)}
              className={classNames(
                styles.cell,
                cell === '.' && styles.nullCell,
                // Logically these are all backwards, not sure why it works
                goingAcross && selectedCell && questionMap[i][j].across === questionMap[selectedCell.y][selectedCell.x].across && styles.wordSelectedCell,
                goingAcross && selectedCell && questionMap[i][j].down === questionMap[selectedCell.y][selectedCell.x].down && styles.offWordSelectedCell,
                !goingAcross && selectedCell && questionMap[i][j].across === questionMap[selectedCell.y][selectedCell.x].across && styles.offWordSelectedCell,
                !goingAcross && selectedCell && questionMap[i][j].down === questionMap[selectedCell.y][selectedCell.x].down && styles.wordSelectedCell,
                selectedCell?.x === j && selectedCell?.y === i && cell !== '.' && styles.selectedCell,
                checkedBoard[i][j] === '+' && styles.correct,
                checkedBoard[i][j] === '-' && styles.incorrect,
              )}
            >
              {questionMap[i][j].first && <div className={styles.numberLabel}>{questionMap[i][j].first}</div>}
              <span className={styles.letter}>{userBoard[i][j] !== '.' && userBoard[i][j]}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default Board